export const iconSize = { width: '28px', height: '30px' }
export const addBorderToAllButTheLastItem = {
  '&:not(:last-child)': {
    '.summary-item-box': {
      borderRight: { sm: 'none', xs: 'none', md: '1px solid #E9ECEF' },
    },
  },
}
